import { Link } from "react-router-dom";
import { EVENTS } from "@/mocks/events";
import SectionHeading from "./SectionHeading";

export default function DeepFeature() {
  const top = [...EVENTS].sort((a, b) => b.heat - a.heat);
  const featured = top[0];
  const others = top.slice(1, 4);

  return (
    <section id="deep" className="mx-auto w-full max-w-7xl scroll-mt-24 px-4 py-14 md:px-6 md:py-20" aria-label="深度解析与来龙去脉">
      <SectionHeading
        icon="ri-search-line"
        kicker="深度解析 · 来龙去脉"
        title="把瓜切开，看里面的纹路"
        desc="不满足于表面爆料？我们把每个事件的前因后果、多方立场与背后动机逐层拆解，还原一条可信的完整时间线。"
      />

      {/* 主打深度专题 */}
      <div className="mt-10 overflow-hidden rounded-3xl bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="relative min-h-[300px] w-full lg:min-h-full">
            <img
              src={featured.cover}
              alt={featured.title}
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-100/70 via-transparent to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-transparent lg:to-background-100"></div>
          </div>
          <div className="p-6 md:p-9">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-vip-crown-2-line" aria-hidden="true"></i>
              本期主打专题
            </span>
            <h3 className="mt-4 text-xl font-extrabold leading-snug text-foreground-950 md:text-2xl">
              {featured.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              {featured.lead}
            </p>

            {/* 真相要点 */}
            <ul className="mt-5 space-y-2.5">
              {featured.truthText.slice(0, 2).map((t, idx) => (
                <li key={idx} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <span className="mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-check-line text-xs text-accent-700" aria-hidden="true"></i>
                  </span>
                  <span className="line-clamp-2">{t}</span>
                </li>
              ))}
            </ul>

            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to={`/story/${featured.id}`}
                className="flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                查看完整时间线
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-time-line" aria-hidden="true"></i>
                时间线 {featured.timeline.length} 个关键节点
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* 其他真相速览 */}
      <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {others.map((item) => (
          <Link
            key={item.id}
            to={`/story/${item.id}`}
            className="group flex flex-col rounded-2xl bg-background-100 p-5 transition-all hover:-translate-y-1 hover:bg-accent-100/60"
          >
            <div className="flex items-center gap-2 text-xs">
              <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-semibold text-secondary-800">
                {item.category}
              </span>
              <span className="text-foreground-400">{item.published}</span>
            </div>
            <h4 className="mt-3 text-base font-bold leading-snug text-foreground-900 group-hover:text-accent-800">
              {item.hotTitle}
            </h4>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
              {item.excerpt}
            </p>
            <span className="mt-auto flex items-center gap-1.5 pt-4 text-sm font-semibold text-accent-700">
              <i className="ri-lightbulb-flash-line" aria-hidden="true"></i>
              读懂背后真相
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}